import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';

import { MAX_ACCESSORY_QUANTITY } from '@/stores/accessoryOrderStore';

type Props = {
  name: string;
  quantity: number;
  onChange: (quantity: number) => void;
};

/**
 * Quantity can be typed or stepped. The draft is kept as text so the field can
 * be emptied mid-edit; it commits on every valid number and snaps back on blur.
 */
export function AccessoryQuantityStepper({ name, quantity, onChange }: Props) {
  const [draft, setDraft] = useState(String(quantity));

  useEffect(() => setDraft(String(quantity)), [quantity]);

  const handleInput = (raw: string) => {
    const digits = raw.replace(/\D/g, '').slice(0, 2);
    setDraft(digits);
    const n = Number(digits);
    if (n >= 1) onChange(n);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      role="group"
      aria-label={`Quantity of ${name}`}
      sx={{ border: 1, borderColor: 'divider', borderRadius: 999, p: 0.5, width: 'fit-content' }}
    >
      <IconButton size="small" aria-label={`Decrease quantity of ${name}`} onClick={() => onChange(quantity - 1)} disabled={quantity <= 1}>
        <Remove fontSize="small" />
      </IconButton>
      <InputBase
        value={draft}
        onChange={(e) => handleInput(e.target.value)}
        onBlur={() => setDraft(String(quantity))}
        onFocus={(e) => e.target.select()}
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          'aria-label': `Quantity of ${name}`,
          className: 'tabular-nums',
          style: { textAlign: 'center', fontWeight: 700, padding: '4px 0' },
        }}
        sx={{ width: 48 }}
      />
      <IconButton
        size="small"
        aria-label={`Increase quantity of ${name}`}
        onClick={() => onChange(quantity + 1)}
        disabled={quantity >= MAX_ACCESSORY_QUANTITY}
      >
        <Add fontSize="small" />
      </IconButton>
    </Stack>
  );
}
